import { BRAND_QUANTITY_EXCEEDED } from "../../../../../services/bag/constants";
import { findErrorsInMessages } from "./findErrorsInMessages";
import { getUserMessageWithContext } from "./getUserMessageWithContext";

export const getErrorMessage = ({ message }) => {
  const brandQuantityExceededMessage = findErrorsInMessages({
    messages: [].concat(message),
    bagErrorCodes: [BRAND_QUANTITY_EXCEEDED]
  });

  if (brandQuantityExceededMessage) {
    return getUserMessageWithContext(brandQuantityExceededMessage);
  }

  return null;
};
